// #region Imports

/* Axios */
import axios from 'axios';

/* Telestream */
import { ConnectionService } from '@/services/connection.service';
import { SET_HISTORY } from '@/utils/mutation-types';
import { FETCH_HISTORY, ADD_TO_HISTORY } from '@/utils/action-types';

// #endregion Imports

// #region Constants

const MAX_HISTORY_SIZE      = 10000;      // TODO this seems rather big?

// #endregion Constants

export const history = {

  // #region State

  state: {
    history: []
  },

  // #endregion State

  // #region Mutations

  mutations: {

    [SET_HISTORY](state, history) {
      state.history = history;
    }

  },

  // #endregion Mutations

  // #region Actions

  actions: {

    async [FETCH_HISTORY](context) {
      const username = await getUsername();
      const history = getPersistedHistory(username);

      context.commit(SET_HISTORY, history);
    },

    async [ADD_TO_HISTORY](context, historyModel) {
      const username = await getUsername();
      let history = getPersistedHistory(username);
      
      history.unshift({
        path: historyModel.path,
        open: historyModel.open,
        date: new Date()
      });

      if (history.length > MAX_HISTORY_SIZE) {
        history = history.slice(0, MAX_HISTORY_SIZE);
      }

      persistHistory(username, history);
      context.commit(SET_HISTORY, history);
    }

  }

  // #endregion Actions

}

// Get the name of the user currently logged in (or null).
async function getUsername() {
  const response = await axios.get(ConnectionService.getUrl('/user'));
  return response.data.name;
}

function getPersistedHistory(username) {
  const localStoragePath = 'glimpsePlayedVideosList_' + username;
  let serializedList = localStorage.getItem(localStoragePath);
  if (!serializedList) {
    serializedList = "[]";
  }

  return JSON.parse(serializedList);
}

function persistHistory(username, history) {
  const localStoragePath = 'glimpsePlayedVideosList_' + username;
  localStorage.setItem(localStoragePath, JSON.stringify(history));
}